import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { FiProgressTimelineComponent } from './fi-progress-timeline.component';
import { FiGradientTimerModule } from '../fi-gradient-timer/fi-gradient-timer.module';

@NgModule({
    declarations: [FiProgressTimelineComponent],
    imports: [CommonModule, MatIconModule, FiGradientTimerModule],
    exports: [FiProgressTimelineComponent],
})
export class FiProgressTimelineModule {}
